import { injectable } from 'inversify';
import 'reflect-metadata';

import { IWarehousesService } from './IWarehousesService.interface';
import { IWarehouseApi, IWarehouseWithBagsApi } from '@@/warehouses/ts';
import { CrudService } from '@@/common/services/crud.service';
import { CrudMeta } from '@@/common/decorators/crud-meta.decorator';
import { post, get } from '@api/api-client';
import { SCHEME2NUMBER_MAP } from '@@/schemes/maps/scheme2number.map';

@injectable()
@CrudMeta({
  modelName: 'warehouse',
  tableName: 'warehouse',
})
// @ts-ignore
export class WarehousesService
  extends CrudService<IWarehouseApi>
  implements IWarehousesService
{
  // @ts-ignore
  override findOneById(id: number): Promise<IWarehouseWithBagsApi> {
    // @ts-ignore
    return super.findOneById(id);
  }

  calculate(options: Parameters<IWarehousesService['calculate']>[0]) {
    return post<Awaited<ReturnType<IWarehousesService['calculate']>>>(
      `${PUBLIC_API_URL}/calculate`,
      {
        ...options,
        type: SCHEME2NUMBER_MAP[options.type],
      },
    );
  }

  statistic(id: number) {
    return get<Awaited<ReturnType<IWarehousesService['statistic']>>>(
      `${PUBLIC_API_URL}/warehouse_stat/${id}`,
    );
  }

  check(name: string) {
    return post<Awaited<ReturnType<IWarehousesService['check']>>>(
      `${PUBLIC_API_URL}/warehouse_check`,
      { name },
    ).catch((error) => {
      console.error('Ошибка при проверке имени склада:', error);
      throw error;
    });
  }
  rename(name: string, id: number) {
    return post<Awaited<ReturnType<IWarehousesService['rename']>>>(
      `${PUBLIC_API_URL}/warehouse/${id}`,
      {
        name,
      },
    );
  }

  copy(id: string, bag_id: string, count: string) {
    return post(`${PUBLIC_API_URL}/copyingbag/${id}`, { bag_id, count });
  }
}
